import { Controller } from "@hotwired/stimulus"

// First-visit tip card. It sits above the bottom bar without covering the page
// (no backdrop, no scroll lock), so it never gets in the way of reading the guide.
export default class extends Controller {
  static targets = ["card"]

  // It waits for the first scroll, tap or key press, so it never holds up the page's first paint (or
  // counts as its largest one)
  connect() {
    if (this.hasSeenWelcome()) return

    this.start = () => {
      this.stopWaiting()
      this.timeout = setTimeout(() => this.show(), 600)
    }
    for (const type of ["scroll", "pointerdown", "keydown"]) addEventListener(type, this.start, { passive: true, once: true })
  }

  disconnect() {
    this.stopWaiting()
    clearTimeout(this.timeout)
  }

  stopWaiting() {
    for (const type of ["scroll", "pointerdown", "keydown"]) removeEventListener(type, this.start)
  }

  show() {
    if (!this.hasCardTarget) return

    this.isOpen = true
    this.cardTarget.classList.remove("opacity-0", "invisible", "translate-y-3", "scale-[0.98]")
  }

  close() {
    this.isOpen = false
    if (this.hasCardTarget) this.cardTarget.classList.add("opacity-0", "invisible", "translate-y-3", "scale-[0.98]")
    this.markAsSeen()
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && this.isOpen) this.close()
  }

  hasSeenWelcome() {
    try {
      return localStorage.getItem("awg-welcome-seen") === "true"
    } catch (e) {
      // Without storage we can't remember a dismissal, so don't show it at all
      return true
    }
  }

  markAsSeen() {
    try {
      localStorage.setItem("awg-welcome-seen", "true")
    } catch (e) {
      // Storage unavailable: nothing to remember
    }
  }
}
